module.exports = "/v2/pages/dashboard/dist/a743b39b2752fc909f233377d190c5a6.svg";